import { Bad } from '@core/model/framework/Result/BadResult';
import { OkVal } from '@core/model/framework/Result/OkResult';
import { Option } from '@core/model/framework/Result/Option';
import { Usecase } from '@core/model/framework/usecase';
import type { BankService } from '@core/model/service/bankService';
import { SERVICE_ID } from '@di/serviceId';
import { ConnectionFormItemDto } from '@modules/process/pages/login/services/dtos/loginDtos';
import { inject, injectable } from 'inversify';

export type GetWebauthUrlOutput = Promise<OkVal<string> | Bad<'GET_WEBAUTH_URL_FAILED'>>;

export type GetWebauthUrlInput = {
  userToken: string;
  bankId: string;
  form: Option<ConnectionFormItemDto[]>;
  tagging: string | undefined;
};

@injectable()
export class GetWebauthUrl implements Usecase<GetWebauthUrlInput, GetWebauthUrlOutput> {
  constructor(
    @inject(SERVICE_ID.bankService)
    private readonly bankService: BankService
  ) {}

  async execute(input: GetWebauthUrlInput): GetWebauthUrlOutput {
    return this.bankService.getWebauthUrl(input);
  }
}
